import React from "react"
import { CircularProgress } from '@mui/material'
import './Spinner.css'

export default function MySpinner({center, hasText = true}) {
  return (
    <div className={`spinner ${center ? 'center' : ''}`}>
      <div className='spinner_container'>
        <CircularProgress animation="border" color="inherit"/>
        {hasText && <div>Loading</div>}
      </div>
    </div>
  )
}
